import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface PropsType {
    className?: string;
    onClick?: () => void;
}

export const ProperBetBrandIcon = observer(
    'ProperBetBrandIcon',
    ({ className, onClick }: PropsType): JSX.Element => (
        <SvgElement
            className={className}
            height='32'
            onClick={onClick}
            viewBox='0 0 131 32'
            width='131'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fill='#2cc4a0'
                d='M130.667 26.66a2.868 2.868 0 1 1-5.735-.001 2.868 2.868 0 0 1 5.735 0'
            />
            <path
                fill='#ede8dc'
                fillRule='evenodd'
                d='M35.681 2.473q3.21 0 4.88 1.746 1.674 1.746 1.675 5.182v12.644q-.001 3.585-1.675 5.533-1.67 1.949-4.88 1.948-3.218 0-4.887-1.96-1.669-1.963-1.668-5.521V9.4q0-3.435 1.668-5.182 1.669-1.746 4.887-1.746m.027 4.887q-1.33 0-1.33 2.009v12.956q0 1.142.276 1.729.28.587 1.027.587.708 0 .954-.615.248-.619.248-1.734V9.308q0-.867-.23-1.405-.232-.544-.945-.543M7.016 2.72q3.188 0 4.545 2.059 1.361 2.055 1.362 6.012-.001 3.958-1.208 5.967-1.203 2.01-4.326 2.01H5.227V29.28H0V2.72zm-1.79 11.254h.308q.96 0 1.405-.351.449-.357.587-1.021.143-.67.143-1.905 0-1.668-.373-2.41-.369-.741-1.482-.741h-.587zM22.755 2.72q1.948.001 3.015.884 1.063.88 1.432 2.47.373 1.595.373 4.068 0 2.257-.587 3.525t-2.036 1.762q1.202.248 1.746 1.208.543.956.543 2.596l-.067 10.047h-5.192V18.893q-.001-1.113-.434-1.421-.435-.314-1.575-.314V29.28h-5.38V2.72zm-2.75 9.832h1.268q1.11 0 1.11-2.41 0-1.053-.094-1.575-.094-.526-.34-.724-.246-.203-.708-.203h-1.236zM51.382 2.72q3.188 0 4.545 2.059 1.36 2.055 1.36 6.012 0 3.958-1.206 5.967-1.204 2.01-4.327 2.01H49.59V29.28h-5.225V2.72zm-1.79 11.254h.306q.96 0 1.407-.351.449-.357.587-1.021.143-.67.143-1.905 0-1.668-.373-2.41-.37-.741-1.484-.741h-.587z'
                clipRule='evenodd'
            />
            <path
                fill='#ede8dc'
                d='M69.591 7.853h-5.22v5.167h5.007v5.006H64.37v6.088h5.561v5.166H58.958V2.72h10.633z'
            />
            <path
                fill='#ede8dc'
                fillRule='evenodd'
                d='M79.86 2.72q1.946.001 3.012.884 1.065.88 1.434 2.47.372 1.595.372 4.068 0 2.257-.587 3.525t-2.036 1.762q1.201.248 1.746 1.208.543.956.543 2.596l-.067 10.047h-5.192V18.893q-.001-1.113-.434-1.421-.435-.314-1.575-.314V29.28h-5.38V2.72zm-2.752 9.832h1.268q1.11 0 1.11-2.41 0-1.053-.094-1.575-.093-.526-.34-.724-.247-.203-.708-.203h-1.236zM93.828 2.72q2.91 0 4.221 1.422 1.313 1.424 1.313 4.64v1.174q0 3.804-2.718 4.546 1.668.434 2.35 2.009.679 1.575.68 4.172 0 4.238-1.268 6.418-1.267 2.18-4.578 2.18h-7.203V2.72zM91.82 24.58l.526.034q2.07 0 2.07-1.982v-3.31q0-1.202-.356-1.818-.352-.62-1.252-.62h-.988zm0-11.874h1.08q.681 0 .93-.51.246-.51.247-1.44V8.102q-.001-1.296-1.142-1.296h-1.115z'
                clipRule='evenodd'
            />
            <path
                fill='#ede8dc'
                d='M112.068 7.853h-5.22v5.166h5.006v5.006h-5.006v6.089h5.561v5.166h-10.974V2.72h10.633zM124.932 7.82h-3.156v21.46h-5.315V7.82h-3.156v-5.1h11.627z'
            />
        </SvgElement>
    )
);
